import React from 'react';
import { Heading, Pane, Card, IconButton, TrashIcon } from 'evergreen-ui';

export default function CardListCard(props) {
    const card = props.card || {};
    const set = card.expansion ? card.expansion.name : (card.expansionName || card.code || '');

    return (
        <Card cursor="pointer">
            <Pane display="flex" justifyContent="space-between" alignItems="center"
                border="default" elevation={1} margin={16} padding={16}>
                <Pane display="flex" alignItems="center">
                    <img style={{ height: '48px', width: 'auto', marginRight: 10 }} alt="card-thumbnail"
                        src={card.thumbnail ?
                            process.env.REACT_APP_CARD_IMAGE_BUCKET + '/' + card.thumbnail : null} />
                    <Heading size={400}>
                        {card.name} {set ? `(${set} #${card.number || ''})` : ''}
                    </Heading>
                </Pane>
                {!props.isView ?
                    <IconButton type="button" icon={TrashIcon} intent="danger" onClick={props.onDelete}>Sterge</IconButton>
                    : null}
            </Pane>
        </Card>
    )
}
